module.exports = __webpack_public_path__ + "static/media/male_2.226ec33d.png";